import React from 'react';
import { useTranslation } from 'react-i18next';

interface EnvToggleProps {
  testId?: string;
  className?: string;
  selectedToggle: ResourceManagementEnvironment;
}

export enum ResourceManagementEnvironment {
  Production,
  Test,
}

export const EnvToggle: React.FC<EnvToggleProps> = ({
  testId,
  className,
  selectedToggle,
}) => {
  const selectedStyle = 'bg-dark-4 text-white noto-13-semibold';
  const { t } = useTranslation();

  return (
    <div
      data-testid={testId}
      className={`flex h-fit w-fit items-center rounded-[5px] bg-light-3 p-[5px] ${className}`}
    >
      <div
        className={`noto-13-semibold flex h-[36px] w-[130px] cursor-pointer items-center justify-center rounded-[5px] bg-dark-4 text-white ${selectedToggle === ResourceManagementEnvironment.Production ? selectedStyle : ''}`}
      >
        {t('management.resource.production')}
      </div>
      <div
        className={`noto-13-normal flex h-[36px] w-[130px] cursor-pointer items-center justify-center rounded-[5px] bg-light-3 text-light-10 ${selectedToggle === ResourceManagementEnvironment.Test ? selectedStyle : ''}`}
      >
        {t('management.resource.testing')}
      </div>
    </div>
  );
};
